import styled from "styled-components";
import UserAddOutlined from "@ant-design/icons/UserAddOutlined";
import React, { CSSProperties, useState } from "react";
import LinkButton from "common/Buttons/LinkButton.tsx";
import ManageInvitationsModal from "features/configuration/InviteExternalUsers/ManageInvitationsModal.tsx";
import { useUser } from "@shared/utils/hooks/misc.ts";
import { CREATE_ACCOUNT_INVITE_FEATURE_FLAG } from "common/constants.ts";
import Text from "common/Typography/Text";
import { selectWorkspace } from "@shared/slices/common.slice.ts";
import { useSelector } from "react-redux";
import { WorkspaceType } from "@shared/types";

interface InviteExternalUserProps {
  style?: CSSProperties;
}

const InviteExternalUser = ({ style }: InviteExternalUserProps) => {
  const { user } = useUser();
  const [manageModalOpen, setManageModalOpen] = useState(false);
  const workspace = useSelector(selectWorkspace);

  if (
    !user ||
    !user?.hasFeatureFlag(CREATE_ACCOUNT_INVITE_FEATURE_FLAG) ||
    user.is_onboarding ||
    workspace === WorkspaceType.DEMO
  )
    return null;

  return (
    <>
      <Wrapper style={style}>
        <Text as="div">
          <UserAddOutlined style={{ marginRight: 8 }} />
          Invite external user
        </Text>
        <LinkButton
          type="link"
          onClick={() => setManageModalOpen(true)}
          style={{ paddingRight: 0 }}
        >
          Manage Invites
        </LinkButton>
      </Wrapper>
      <ManageInvitationsModal
        open={manageModalOpen}
        onCancel={() => setManageModalOpen(false)}
      />
    </>
  );
};

export default InviteExternalUser;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background-color: ${(p) => p.theme.colors.statisticsBgColor};
  border-radius: 8px;
`;
